import { Center, Heading, Spinner, Text } from "@chakra-ui/react"
import useMaintenance from "hooks/use-maintenance"

const Maintenance = () => {
  const { isLoading, data, retryAfter, app } = useMaintenance()

  if (isLoading || (data && data.result === 'ok')) {
    return (
      <Center py={8}>
        <Spinner size={"lg"} color={"gray.500"} />
      </Center>
    )
  }

  return (
    <>
      <Heading textAlign="center">
        Down for maintenance
      </Heading>
      <Text textAlign="center" color="brand.400" marginTop="4">
        {app.name} is currently down for scheduled maintenance.
        {retryAfter && 
          ` We expect it to be available again by ${retryAfter}.`
        }
      </Text>
    </>
  )
}

export default Maintenance
